import { useMemo } from "react";

import { CURRENT_EVENT_SLUG } from "src/shared/constants/event";

import { useGetAllHardwareCategoriesQuery } from "../graphql/getAllHardwareCategories.generated";
import { useGetAllHardwareSkusQuery } from "../graphql/getAllHardwareSkus.generated";
import { useGetHardwareItemsQuery } from "../graphql/getHardwareItems.generated";

import {
  THardwareCategory,
  THardwareSku,
  toInventoryItems,
} from "./hardwareModels";

export const useGetHardwareInfo = ({ includeItems = false } = {}) => {
  const {
    data: hardwareCategoriesData,
    loading: hardwareCategoriesDataLoading,
    error: hardwareCategoriesDataError,
    refetch: refetchHardwareCategories,
  } = useGetAllHardwareCategoriesQuery({
    variables: { event_slug: CURRENT_EVENT_SLUG },
  });

  const {
    data: hardwareSkusData,
    loading: hardwareSkusDataLoading,
    error: hardwareSkusDataError,
    refetch: refetchHardwareSkus,
  } = useGetAllHardwareSkusQuery();

  const {
    data: hardwareItemsData,
    loading: hardwareItemsLoading,
    error: hardwareItemsDataError,
    refetch: refetchHardwareItems,
  } = useGetHardwareItemsQuery({
    variables: { where: {}, event_slug: CURRENT_EVENT_SLUG },
    skip: !includeItems,
  });

  const hardwareCategories: THardwareCategory[] =
    hardwareCategoriesData?.getHardwareCategories || [];

  const hardwareSkus: THardwareSku[] = hardwareSkusData?.getHardwareSkus || [];

  const hardwareItems = hardwareItemsData?.hardwareItems || [];

  const inventoryItems = useMemo(
    () => toInventoryItems(hardwareItems, hardwareSkus),
    [hardwareItems, hardwareSkus]
  );

  return {
    hardwareCategories,
    hardwareSkus,
    hardwareItems,
    inventoryItems,
    hardwareCategoriesDataLoading,
    hardwareSkusDataLoading,
    hardwareItemsLoading: includeItems && hardwareItemsLoading,
    hardwareCategoriesDataError,
    hardwareSkusDataError,
    hardwareItemsDataError,
    refetchHardwareCategories,
    refetchHardwareSkus,
    refetchHardwareItems,
  };
};
